import { formatFiatUnits } from '../amount/format-money.js';
import { unitsToDecimal } from '../amount/money.js';
/** Display provider-defined token minima and basis points without floating-point rounding. */
export function cryptoDepositTerms(route, locale) {
    const minimum = route.minimumUnits !== null
        ? {
            amount: exactAmount(unitsToDecimal(BigInt(route.minimumUnits), route.decimals), locale, route.asset === 'USDC'),
            asset: route.asset,
        }
        : route.minimumUsd !== null
            ? { amount: exactAmount(route.minimumUsd, locale, true), asset: null }
            : null;
    const feeBps = route.feeBps;
    const fee = feeBps === null
        ? null
        : new Intl.NumberFormat(locale, { style: 'percent' })
            .formatToParts(0n)
            .map((part) => part.type === 'integer'
            ? exactAmount(unitsToDecimal(BigInt(feeBps), 2), locale, false)
            : part.value)
            .join('');
    return { minimum, fee };
}
function exactAmount(decimal, locale, usd) {
    const [whole = '0', paddedFraction = ''] = decimal.split('.');
    const fraction = paddedFraction.replace(/0+$/, '');
    if (usd)
        return formatFiatUnits(`${whole}${fraction}`, fraction.length, 'USD', locale);
    const formatter = new Intl.NumberFormat(locale);
    const digits = new Intl.NumberFormat(locale, { useGrouping: false });
    const separator = formatter.formatToParts(1.1).find((part) => part.type === 'decimal')?.value;
    return (formatter.format(BigInt(whole)) +
        (fraction
            ? `${separator}${[...fraction].map((digit) => digits.format(BigInt(digit))).join('')}`
            : ''));
}
